export default "__VITE_PUBLIC_ASSET__c2245225__"